// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e7ab6e80","845":"99363042"}[chunkId] + ".chunk.js";
};